import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormGroup,
  InputAdornment,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCreateLonOutTransaction } from '../../hooks/useCreateLonOutTransaction';
import { numberWithPoint } from '../../utils/utils';
import { ButtonsPrimary } from '../ComponentApp/buttoms';
import { InvestmentPortfolioModal } from '../portfolio/InvestmentPortfolioModal';
import Spinner from '../Spinner';
import ModalActions, { SuccessfulInvestment } from '../UI/modalActions';
import {
  AvailableBalanceBox,
  BackArrowContainer,
  BlueCard,
  CardTitle,
  ContainerTypos,
  FormLabelStyled,
  ImgStyled,
  InputLabelBox,
  InvestmentContainer,
  InvestmentInputStack,
  InvestmentLabel,
  InvestmentTextField,
  LeftColumnWrapper,
  MainBodyStack,
  RechargeLink,
  RechargeWrapper,
  RightColumnWrapper,
  SectionTitle,
  TitleSection,
  TitleSectionWrapper,
  Typography1,
  Typography2,
  WarningBox,
  WarningIcon,
  WarningMessageStack,
  WarningText,
} from './SimulationComponents/SimulationMuiComponents';
import { useProcessPortfolioBuys } from '../../hooks/useProcessPortfolioBuys';

const SimulatorInvestmentPortfolio = ({
  dataChart,
  formData,
  portfolioName,
  typePayment,
  balanceData,
  userRisk,
  userRiskCondition,
  profilePortfolio,
  refetch,
  resetFormData,
  loadingBalance,
}) => {
  const { id } = useParams();
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);
  const [openModalPortfolio, setOpenModalPortfolio] = useState(false);
  const [sending, setSending] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [amount, setAmount] = useState({
    initialInvestment: location.state?.fromCard ? '' : formData?.initialInvestment || '',
  });

  const [checked, setChecked] = useState({
    checkbox1: false,
    checkbox2: false,
  });

  const [
    createLongOutTransaction,
    { error: errorPorfolioInvestment, loading: isLoadingInvesment },
  ] = useCreateLonOutTransaction();

  const [processPortfolioBuys, { error: errorPortfolioInvestment, loading: isLoadingInvestment }] =
    useProcessPortfolioBuys();

  const openTC = () => {
    const { REACT_APP_CONTRACT } = process.env;
    const win = window.open(REACT_APP_CONTRACT, '_blank');
    win.focus();
  };

  const getDisabled = () => {
    const { initialInvestment } = amount;
    const { checkbox1, checkbox2 } = checked;
    if (!initialInvestment) {
      return true;
    }

    const amountDynamic = 200000;
    if (initialInvestment && userRiskCondition) {
      return (
        Number.parseInt(initialInvestment?.replace(/\D/g, '')) < amountDynamic ||
        balanceData?.balance < Number.parseInt(initialInvestment?.replace(/\D/g, '')) ||
        initialInvestment[0] === '0' ||
        initialInvestment === null ||
        initialInvestment.trim() === '' ||
        !checkbox2 ||
        sending
      );
    } else if (initialInvestment && !userRiskCondition) {
      return (
        Number.parseInt(initialInvestment?.replace(/\D/g, '')) < amountDynamic ||
        balanceData?.balance < Number.parseInt(initialInvestment?.replace(/\D/g, '')) ||
        initialInvestment[0] === '0' ||
        initialInvestment === null ||
        initialInvestment.trim() === '' ||
        !(checkbox1 && checkbox2) ||
        sending
      );
    }
  };

  const disable = getDisabled();

  const result = dataChart || null;
  const safeResult = result || {};

  const fundName =
    safeResult?.name || safeResult?.Name || safeResult?.fileAs || safeResult?.fileAsComplete || '';

  const funId = safeResult?.id || safeResult?.ID || safeResult?.idModels || '';

  const handleCloseModalPortfolio = () => {
    setOpenModalPortfolio(false);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleChangeCheckBox = e => {
    const { name, checked: checkedInput } = e.target;
    setChecked({
      ...checked,
      [name]: checkedInput,
    });
  };

  const handleChangeAmount = e => {
    const { name, value } = e.target;
    const validAmount = value?.replace(/\D/g, '');
    if (validAmount?.toString()?.length <= 8) {
      const format = numberWithPoint(validAmount);

      setAmount(prevAmount => ({
        ...prevAmount,
        [name]: format,
      }));
    }
  };

  const handleSubmitInvestment = async (amount, fundName, funId) => {
    setSending(true);

    const dataInvestment = {
      FileAs: fundName,
      ModelID: funId,
      amount: Number.parseInt(amount?.initialInvestment?.replace(/\D/g, '')),
      note: fundName,
    };

    try {
      setOpenModalPortfolio(true);
      const { data: responseCreateLongOut } = await processPortfolioBuys({
        variables: {
          data: dataInvestment,
        },
      });

      if (responseCreateLongOut.processPortfolioBuys) {
        await new Promise(resolve => setTimeout(resolve, 3000));
        refetch();
      }

      setOpenModalPortfolio(false);
      setOpenModal(true);
    } catch (error) {
      console.error(error);
    } finally {
      setSending(false);
      setChecked({
        ...checked,
        checkbox1: false,
        checkbox2: false,
      });
    }
  };

  const validateAmount = value => {
    let errors;

    if (value.trim() === '') {
      errors = 'El campo es requerido';
    } else if (
      !value ||
      Number.parseInt(value?.replace(/\D/g, ''), 10) < 200000 ||
      value[0] === '0'
    ) {
      errors = 'El monto mínimo para invertir en este portafolio es de $200.000';
    }

    return errors;
  };

  const errorAmount = validateAmount(amount.initialInvestment);

  if (isLoadingInvesment || loadingBalance) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          boxSizing: 'border-box',
          width: '100%',
          top: { md: '100px', xs: '50px' },
        }}>
        <Spinner />
      </Box>
    );
  }

  return (
    <>
      <InvestmentPortfolioModal open={openModalPortfolio} onClose={handleCloseModalPortfolio} />
      <ModalActions open={openModal}>
        <SuccessfulInvestment
          amountInvestment={amount.initialInvestment}
          portfolioName={portfolioName}
          onClose={handleClose}
        />
      </ModalActions>

      <Stack
        sx={{
          position: 'relative',
          margin: '0 auto',
          top: { md: 0, xs: '20px' },
          width: '90%',
        }}
        justifyContent={'center'}
        alignItems={'center'}
        gap={'4rem'}>
        <BackArrowContainer>
          <Button
            onClick={() => navigate(-1)}
            style={{ background: 'none', border: 'none', padding: 0 }}>
            <ImgStyled src='/assets/images/Arrow1.svg' alt='Arrow' />
          </Button>
        </BackArrowContainer>

        <MainBodyStack sx={{ marginTop: '-48px' }}>
          <LeftColumnWrapper>
            <TitleSectionWrapper>
              <TitleSection>{portfolioName}</TitleSection>
            </TitleSectionWrapper>

            <BlueCard>
              <Stack>
                <CardTitle>Condiciones generales</CardTitle>
              </Stack>
              <ContainerTypos>
                <Typography1>Moneda fondos: </Typography1>
                <Typography2>{typePayment === 'clp' ? 'Pesos' : 'USD'}</Typography2>
              </ContainerTypos>
              <ContainerTypos>
                <Typography1>{'Monto mínimo de inversión(en pesos):'}</Typography1>
                <Typography2>{'$200.000'} </Typography2>
              </ContainerTypos>
              <ContainerTypos>
                <Typography1>Plazo de rescate: </Typography1>
                <Typography2>Según reglamentos de los fondos </Typography2>
              </ContainerTypos>
              <ContainerTypos>
                <Typography1>Comisión de salida: </Typography1>
                <Typography2>Según reglamentos de los fondos</Typography2>
              </ContainerTypos>
            </BlueCard>
          </LeftColumnWrapper>
          <RightColumnWrapper>
            <SectionTitle>
              <TitleSection>Inversión</TitleSection>
            </SectionTitle>
            <BlueCard>
              <Stack>
                <CardTitle>Elige cuánto deseas invertir</CardTitle>
              </Stack>

              <InvestmentContainer>
                <InvestmentInputStack>
                  <InputLabelBox>
                    <InvestmentLabel>Inversión Inicial</InvestmentLabel>
                    <InvestmentTextField
                      fullWidth
                      variant='standard'
                      type='text'
                      name='initialInvestment'
                      InputProps={{
                        startAdornment: <InputAdornment position='start'>$</InputAdornment>,
                        fontSize: theme.typography.availableBalance.fontSize,
                      }}
                      onChange={handleChangeAmount}
                      value={amount.initialInvestment}
                      error={Boolean(errorAmount)}
                      helperText={errorAmount}
                    />
                  </InputLabelBox>
                  <AvailableBalanceBox>
                    <img
                      style={{
                        backgroundColor: '#edfcf9',
                        marginRight: '4px',
                      }}
                      width={'26px'}
                      height='26px'
                      src='/assets/images/cashBox.gif'
                      alt='gift'
                    />
                    * Monto Disponible ${numberWithPoint(Math.round(balanceData?.balance))}
                  </AvailableBalanceBox>

                  {balanceData?.balance <
                  Number.parseInt(amount.initialInvestment?.replace(/\D/g, '')) ? (
                    <WarningBox>
                      <img
                        style={{
                          backgroundColor: 'rgb(220, 53, 69,0.1)',
                          marginRight: '4px',
                        }}
                        width={'26px'}
                        height='26px'
                        src='/assets/images/cashBox.gif'
                        alt='gift'
                      />
                      *
                      {` Monto por recargar $${numberWithPoint(
                        Number.parseInt(
                          amount.initialInvestment?.replace(/\D/g, '') - balanceData.balance,
                        ),
                      )}`}
                    </WarningBox>
                  ) : null}
                </InvestmentInputStack>
              </InvestmentContainer>

              {balanceData?.balance <
                Number.parseInt(amount.initialInvestment?.replace(/\D/g, '')) && (
                <RechargeWrapper>
                  <WarningMessageStack>
                    <WarningIcon
                      component='img'
                      src='/assets/images/maintenancetriangle.svg'
                      alt='Ícono de advertencia'
                    />
                    <WarningText sx={{ ml: '6px' }}>
                      No tienes suficientes fondos en caja
                    </WarningText>
                  </WarningMessageStack>
                  <Stack width={'100%'} alignItems='center'>
                    <RechargeLink
                      as='button'
                      onClick={() => {
                        navigate('/payments');
                      }}>
                      Recargar caja
                    </RechargeLink>
                  </Stack>
                </RechargeWrapper>
              )}
            </BlueCard>
          </RightColumnWrapper>
        </MainBodyStack>

        <Stack width={'100%'} marginTop={'-20px'}>
          <Box>
            <Typography
              sx={{
                fontSize: {
                  xs: theme.typography.button.fontSize,
                  md: theme.typography.availableBalance.fontSize,
                },
              }}
              fontWeight={theme.typography.littleText.fontWeight}
              color={theme.palette.primary.main}>
              Este portfolio genera dividendos mensuales.
            </Typography>
          </Box>
          <Box sx={{ mt: '10px' }}>
            <Typography
              sx={{
                fontSize: {
                  xs: theme.typography.returnText.fontSize,
                  md: theme.typography.availableBalance.fontSize,
                },
              }}
              fontWeight={theme.typography.littleText.fontWeight}
              color={theme.palette.primary.darkBlue}>
              Los dividendos o disminuciones de capital generados por los fondos de este portfolio,
              serán cargados directamente en caja cada vez que se paguen.
            </Typography>
          </Box>
        </Stack>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '-20px',
          }}>
          <FormGroup
            sx={{
              gap: '10px',
            }}>
            {userRiskCondition ||
            userRisk === 'agresivo' ||
            (userRisk === 'moderado' &&
              profilePortfolio
                ?.replace(/\bCLP\b\s*/g, '')
                ?.trim()
                ?.toLowerCase() === 'conservador') ? null : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  width: '100%',
                  justifyContent: 'center',
                  width: '100%',
                  flexWrap: 'wrap',
                }}>
                <Checkbox
                  checked={checked.checkbox1}
                  name='checkbox1'
                  onChange={handleChangeCheckBox}
                />
                <FormLabelStyled>
                  Declaro entender que la inversión que estoy realizando es de un riesgo superior a
                  lo sugerido por mi perfil inversionista.
                </FormLabelStyled>
              </Box>
            )}

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}>
              <Checkbox
                checked={checked.checkbox2}
                name='checkbox2'
                onChange={handleChangeCheckBox}
              />
              <FormLabelStyled>
                {'Acepto que esta transacción se rigen bajo las normas del '}
                {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                <span
                  onClick={openTC}
                  style={{
                    cursor: 'pointer',
                    color: theme.palette.secondary.main,
                    fontWeight: theme.typography.button.fontWeight,
                  }}>
                  contrato vigente.
                </span>
              </FormLabelStyled>
            </Box>
          </FormGroup>
        </Box>

        <Stack alignItems={'center'} justifyContent={'space-between'} mt={-4} width={'90%'}>
          <Box width={{ lg: '35%', md: '40%', sm: '60%', xs: '80%' }}>
            <ButtonsPrimary
              name='Invertir'
              onClick={() => {
                handleSubmitInvestment(amount, fundName, funId);
                resetFormData();
              }}
              disabled={disable}
              fullWidth
            />
          </Box>

          <Box mt={3} mb={3}>
            {balanceData?.balance <
            Number.parseInt(amount.initialInvestment?.replace(/\D/g, '')) ? (
              <Alert severity='info'>
                Por favor valida el monto ingresado, el monto es mayor al disponible en caja.
              </Alert>
            ) : !amount.initialInvestment ||
              Number.parseInt(amount.initialInvestment?.replace(/\D/g, '')) < 200000 ? (
              <Alert severity='info'>
                Por favor valida el monto ingresado, el monto mínimo para invertir en este portfolio
                es de $200.000.
              </Alert>
            ) : amount.initialInvestment.trim() === '' ? (
              <Alert severity='info'>Por favor ingrese un monto a invertir</Alert>
            ) : checked.checkbox1 && checked.checkbox2 ? (
              <Alert severity='success'>Todo está listo para invertir</Alert>
            ) : null}
          </Box>

          <Box
            display={'flex'}
            justifyContent={'center'}
            width={'150px'}
            height={'40px'}
            sx={{
              marginBottom: {
                xs: '28px',
                md: '8px',
              },
              marginTop: {
                xs: '-10px',
                md: '0px',
              },
            }}>
            <Link to={'/'}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  color: 'rgba(239, 140, 122, 1)',
                  fontWeight: theme.typography.smallText.fontWeight,
                  fontSize: theme.typography.button.fontSize,
                  textDecoration: 'underline',
                }}>
                No por ahora
              </Typography>
            </Link>
          </Box>
        </Stack>
      </Stack>
    </>
  );
};

export default SimulatorInvestmentPortfolio;
